import React from 'react';
import { BaseStagePlugin } from '@/framework';
import { PluginType, type IExportPlugin } from '@/version-types';
import { IntelligentColorPlugin } from './controller';
import { useInit } from './hooks/use-init';
import intelligentColorPluginState, { useIntelligentColorState } from './states/intelligent-color-state';
import { ColorPickPen } from './views/color-pick-pen';
import { SmartMaskPen } from './views/smart-mask-pen';

const IntelligentColorPluginView: React.FC = React.memo(() => {
    const isProtectPen = useIntelligentColorState()((state) => state.isProtectPen);
    const isOpenIntelligentPickColor = useIntelligentColorState()((state) => state.isOpenIntelligentPickColor);

    useInit();

    if (!isProtectPen && !isOpenIntelligentPickColor) return null;

    return (
        <BaseStagePlugin enablePointerEvents name="intelligent-color">
            {isOpenIntelligentPickColor && <ColorPickPen />}
            {isProtectPen && <SmartMaskPen />}
        </BaseStagePlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 10,
    name: 'intelligent-color',
    render() {
        return <IntelligentColorPluginView />;
    },
    createInstance({ identity }) {
        return [{ key: 'IntelligentColorPlugin', value: new IntelligentColorPlugin(identity) }];
    },
    createState() {
        return [intelligentColorPluginState];
    },
};

export default exportPlugin;
